import client from 'api/graphQL/config'
import {gql, TypedDocumentNode} from '@apollo/client'
import {DatabaseMetadataFilterInput, Query} from 'graphql-api'

const fragments = {
  databaseDetailsFields: gql`
    fragment databaseDetailsFields on DatabaseMetadata {
      databaseId,
      databaseName,
      databaseVersion,
      databaseType {
        isStudy,
        isStudyGroup
      },
      raveUrl,
      sqlServerId,
      sqlServerName,
      studyGroupUuids,
      studyUuids,
      lastSyncTimeStamp,
      active,
      enabled,
      isClassic,
      appVersion
      hostname
    }
  `,
}

export const GET_DATABASES: TypedDocumentNode<Query> = gql`
  query GetDatabases(
    $where: DatabaseMetadataFilterInput,
  ) {
    databases(
      where: $where,
    )
    {
      raveUrl
      hostname
      databaseId
      databaseVersion
      appVersion
      active
      enabled
      studyGroupUuids
    }
  }
`

const GET_DATABASE_DETAILS: TypedDocumentNode<Query> = gql`
  query GetDatabaseDetails(
    $databaseId: UUID
  ) {
    databases (
      where: {databaseId: {eq: $databaseId}}
    ) {
      ...databaseDetailsFields
    }
  }

  ${fragments.databaseDetailsFields}
`
const GET_DATABASE_URLS: TypedDocumentNode<Query> = gql`
  query GetDatabases {
    databases {
      raveUrl
      databaseId
      hostname
    }
  }
`
const GET_ACTIVE_AND_ENABLED_DATABASE_URLS: TypedDocumentNode<Query> = gql`
  query GetDatabases {
    databases (
      where: {
        active: {eq: true},
        or: [
          {enabled: {eq: true}},
          {enabled: {eq: null}}
        ]
      }
    ) {
      raveUrl
      databaseId
      hostname
      enabled
    }
  }`

const GET_ACTIVE_DATABASE_URLS: TypedDocumentNode<Query> = gql`
  query GetDatabases {
    databases (
      where: {active: {eq: true}}
    ) {
      raveUrl
      databaseId
      hostname
      enabled
    }
  }`

const GET_FEATURE_FLAGS = gql`
  query featureFlags (
    $databaseId: UUID!
  ) {
    featureFlags (
      databaseId: $databaseId
    ) {
      name
      status
    }
  }`

const GET_JOB_TYPE_OPTIONS = gql`
  query jobTypeOptions {
    jobTypeOptions {
      jobType
      enableFeatureFlagName
      pauseFeatureFlagName
      overrides
    }
  }`

const GET_CUSTOM_CONFIG_OVERRIDES = gql`
  query customConfigOverrides (
    $databaseId: UUID!,
    $customConfigOverrides: [String!]!
  ) {
    customConfigOverrides (
      databaseId: $databaseId
      customConfigOverrides: $customConfigOverrides
    ) {
      name
      value
    }
  }`

const GET_CONFIGURATION_OPTIONS = gql`
  query configurationOptions {
    configurationOptions {
      groupName
      label
      tag
      type
    }
  }`

export const getDatabases = (
  where: DatabaseMetadataFilterInput
) => {

  return client.query({
    query: GET_DATABASES,
    variables: {
      where,
    },
  })
}

export const getDatabaseDetails = (databaseId: string) => client.query({
  query: GET_DATABASE_DETAILS,
  variables: {
    databaseId,
  },
})

export const getActiveAndEnabledDatabaseUrls = () => client.query({
  query: GET_ACTIVE_AND_ENABLED_DATABASE_URLS,
})

export const getActiveDatabaseUrls = () => client.query({
  query: GET_ACTIVE_DATABASE_URLS,
})

export const getFeatureFlags = (databaseId: string) =>
  client.query({
    query: GET_FEATURE_FLAGS,
    variables: {
      databaseId
    }
  })

export const getRaveUrlFilterData = () =>
  client.query({
    query: GET_DATABASE_URLS,
  })

export const getJobTypeOptions = () =>
  client.query({
    query: GET_JOB_TYPE_OPTIONS,
  })

export const getCustomConfigOverrides = (databaseId: string, customConfigOverrides: string[]) =>
  client.query({
    query: GET_CUSTOM_CONFIG_OVERRIDES,
    variables: {
      databaseId,
      customConfigOverrides
    }
  })

export const getConfigurationOptions = () =>
  client.query({
    query: GET_CONFIGURATION_OPTIONS,
  })
